import { render, staticRenderFns } from "./UTMsCard.vue?vue&type=template&id=7c8d19dd&scoped=true"
import script from "./UTMsCard.vue?vue&type=script&lang=js"
export * from "./UTMsCard.vue?vue&type=script&lang=js"
import style0 from "./UTMsCard.vue?vue&type=style&index=0&id=7c8d19dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d19dd",
  null
  
)

export default component.exports